import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect, useRef } from 'react';
import { isAdminUser } from '../../utils/adminUserTypes';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Grid,
  Menu,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  CircularProgress,
  Tooltip,
  IconButton,
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { Icon } from '@iconify/react';
import arrowIosUpwardFill from '@iconify/icons-eva/arrow-ios-upward-fill';
import arrowIosDownwardFill from '@iconify/icons-eva/arrow-ios-downward-fill';
import closeFill from '@iconify/icons-eva/close-fill';
// redux
import { useDispatch, useSelector } from 'src/redux/store.js';
import { getUserList, deleteUser } from 'src/redux/slices/user.js';
// import { UserMoreMenu } from 'src/components/_dashboard/user/list/index.js';

// routes
// components
import Page from 'src/components/Page.js';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Label from 'src/components/Label.js'; 
import Scrollbar from 'src/components/Scrollbar.js';
import SearchNotFound from 'src/components/SearchNotFound.js';
import { UserListHead, UserListToolbar, UserMoreMenu } from 'src/components/_dashboard/user/list/index.js';
import  ProjectListViewToolbar  from 'src/components/_dashboard/user/list/ProjectListViewToolbar';
import  ProjectListMenu  from 'src/components/_dashboard/user/list/ProjectListMenu';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { COMPANY_LOGO, REST_API_END_POINT } from 'src/constants/Defaultvalues';
import LoadingScreen from 'src/components/LoadingScreen';
import FullScreenDialogsAllJobs from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogsAllJobs';
import quickbookLogo from '../../assets/quickbookLogo-removebg-preview.png'

import { Form, Formik, FormikProvider } from 'formik';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import { empty } from 'src/Helpers/Common';
import moment from 'moment/moment';
import { Chip } from '@mui/material';
import { EmojiEvents, Payment, CallSplit } from '@material-ui/icons';
import AnimatedButton from 'src/components/animate/AnimatedButton';
import { SalesOrderNewBadgeList, getSalesOrderNewRowSx } from 'src/components/_dashboard/official-request/SalesOrderNewBadge';
import useTableMaxHeight from 'src/hooks/useTableMaxHeight';


// ----------------------------------------------------------------------

  const option = [
    { id: 0, value: 'Inactive' },
    { id: 1, value: 'New' },
    { id: 2, value: 'Open' },
    { id: 3, value: 'Completed' },
    { id: 4, value: 'Hold' },
    { id: 5, value: 'Accepted' },
    { id: 6, value: 'Rejected' },
    { id: 7, value: 'Verified' },
    { id: 6, value: 'Reopen' },
  ]

  const colors = [
    'error',
    'primary',
    'secondary',
    'success',
    'warning',
    'success',
    'error',
    'success',
    'error',
  ]
  
  
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

const onboard_data=[
    {
        id:0,
        status:'Pending',
        name:'Laffety',
        number:'123456789',
        address:'California',
        total:'23925.00 USD',
        createdon:'12/31/1969',
    },
    {
        id:1,
        status:'Pending',
        name:'K Hovnanian',
        number:'6532611678',
        address:'Manteca',
        total:'11990.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:2,
        status:'Pending',
        name:'Chase Brendle',
        number:'1215165265',
        address:'San Francisco',
        total:'24480.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:3,
        status:'Pending',
        name:'Jane Doe',
        number:'281728173',
        address:'Sedona',
        total:'68206.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:4,
        status:'Pending',
        name:'Adam Sandler',
        number:'3152614141',
        address:'Miami',
        total:'14280.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:5,
        status:'Pending',
        name:'Umila Garib',
        number:'2728738268',
        address:'West Palm Beach',
        total:'11990.00 USD',
        createdon:'12/31/1969',

    },
]


  const getStatusColorAndLabelQuickbid = (status, quotation, estimate_job_status, hold, manager_approval_required, send_client_app_req, send_to_client, send_for_manager_approval, is_request_estimate) => {
    if (Number(status) === 12) {
      return { color: 'error', label: 'Void' }
    }
    if (hold == 1) {
      return { color: 'warning', label: 'Hold' }
    }
    const sentToClient = send_client_app_req == 1 || send_to_client == 1
    const isRequestEstimate = is_request_estimate == 1
    const estimateJobComplete = Number(estimate_job_status) === 3
    const managerReviewPending =
      (manager_approval_required === 1 || manager_approval_required === true) &&
      (send_for_manager_approval === 1 || send_for_manager_approval === true) &&
      !sentToClient
    const isEstimateReview =
      status !== 1 &&
      (!isRequestEstimate || estimateJobComplete) &&
      managerReviewPending
    if (isEstimateReview) {
      return { color: 'info', label: 'Review/ Send for Approval' }
    }
    switch (status) {
      case 1:
        return { color: 'warning', label: 'Draft' }
      case 2:
        return { color: 'info', label: sentToClient ? 'Awaiting Approval' : 'New' }
      case 3:
        if (isRequestEstimate) {
          return {
            color: estimate_job_status == 3 ? 'info' : estimate_job_status == 2 ? 'info' : 'primary',
            label: estimate_job_status == 3 ? 'Review/ Send for Approval' : estimate_job_status == 2 ? 'In Progress' : 'In Queue',
          }
        }
        return {
          color: managerReviewPending ? 'info' : estimate_job_status == 2 ? 'info' : 'primary',
          label: managerReviewPending
            ? 'Review/ Send for Approval'
            : estimate_job_status == 2
            ? 'In Progress'
            : 'In Queue',
        }
      case 4:
        return {
          color: quotation == 0 ? 'default' : 'success',
          label: quotation == 0 ? 'Archive' : 'Approved',
        }
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        return { color: 'error', label: 'Rejected' }
      case 9:
        if (isRequestEstimate) {
          return {
            color:
              Number(estimate_job_status) !== 3
                ? estimate_job_status == 2
                  ? 'info'
                  : 'primary'
                : 'info',
            label:
              Number(estimate_job_status) !== 3
                ? estimate_job_status == 2
                  ? 'In Progress'
                  : 'In Queue'
                : (manager_approval_required === true || manager_approval_required === 1) &&
                    (send_for_manager_approval === true || send_for_manager_approval === 1) &&
                    !sentToClient
                  ? 'Review/ Send for Approval'
                  : sentToClient
                  ? 'Awaiting Approval'
                  : (manager_approval_required === true || manager_approval_required === 1)
                  ? 'Awaiting Manager Approval'
                  : 'Awaiting Approval',
          }
        }
        return {
          color: 'info',
          label:
            (manager_approval_required === true || manager_approval_required === 1) &&
            (send_for_manager_approval === true || send_for_manager_approval === 1) &&
            !sentToClient
              ? 'Review/ Send for Approval'
              : sentToClient
              ? 'Awaiting Approval'
              : (manager_approval_required === true || manager_approval_required === 1)
              ? 'Awaiting Manager Approval'
              : 'Awaiting Approval',
        }
      case 10:
        if (isRequestEstimate) {
          return {
            color: estimate_job_status == 3 ? 'info' : estimate_job_status == 2 ? 'info' : 'primary',
            label:
              estimate_job_status == 3
                ? 'Review/ Send for Approval'
                : estimate_job_status == 2
                ? 'In Progress'
                : 'In Queue',
          }
        }
        return { color: 'info', label: 'Review/ Send for Approval' }
      case 11:
        return { color: 'error', label: 'Rejected by Manager' }
      case 12:
        return { color: 'error', label: 'Void' }
      default:
        return { color: 'default', label: 'Open' }
    }
  }
  const getStatusColorAndLabelForProposal = (status) => {
    switch (status) {
      case 1:
        return { color: 'info', label: 'Open' }
      case 2:
        return { color: 'warning', label: 'Awarded' }
      case 3:
        return { color: 'error', label: 'Rejected' }
      case 4:
        return { color: 'success', label: 'Approved' }
      case 5:
        return { color: 'warning', label: 'Closed' }
      case 6:
        return { color: 'error', label: 'Rejected' }
      case 7:
        return { color: 'success', label: 'Paid' }
      default:
        return { color: 'info', label: 'Open' }
    }
  }
export default function   DesignOrderList({projectData, noImage,
    accept_status,
    currentTab,
    designOrder,
    estimate,
    salesOrder,
    CommunityJob,
    communityRfqListState,
    CommunityInstalls,
    communityInstallsListState,
    totalCount,
    rowsPerPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
    fromClient,
    setRenderCards,
    renderCards,
    handleOpenDetails,
    handleOpenViewEstimate,
    CommunityProjects,
    quotationView,
    proposalView,
    communityDesignOrder,
    handleOpenViewSalesOrder ,
    handleOpenDetailsSalesOrder,
    handleOpenViewPurchaseOrder,
    handleOpenDetailsPurchaseOrder,
    installsJobs,
    cinstalls,
    isDesign,
    handleOpenViewDesignOrder,
    handleOpenDetailsDesignOrder,
    onProposalAwardAction,
    awardActionLoadingId,
    enableInvoiceGroupAccordion = false,
    isInvoiceListGroupingEnabled = false,
    selectedInvoiceGroupIds = [],
    canShowInvoiceGroupCheckbox,
    onToggleInvoiceGroupSelection,
    onUngroupInvoiceRequests,
    ungroupingInvoiceRequests = false,
    onClearInvoiceGroupSelection,
    invoiceGroupActionBarVisible = false,
}) {
  const communitySalesOrderNavigateState = {
    fromCommunitySalesOrder: true,
    ...(communityRfqListState ? { communityRfqListState } : {}),
  }
  const communityInstallsNavigateState = {
    fromCommunityInstalls: true,
    ...(communityInstallsListState ? { communityInstallsListState } : {}),
  }
  const communityJobNavigateState = CommunityInstalls
    ? communityInstallsNavigateState
    : communitySalesOrderNavigateState
  const theme = useTheme();
  const dispatch = useDispatch();
  const tableScrollRef = useRef(null);
  const tableMaxHeight = useTableMaxHeight(
    tableScrollRef,
    [projectData?.length, rowsPerPage, page, currentTab]
  );
  const UsersListV = onboard_data; // Replaced UsersListV with onboard_data
//   const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
//   const [rowsPerPage, setRowsPerPage] = useState(10);
  const { enqueueSnackbar } = useSnackbar();
  const navigate=useNavigate()
  const [isDelete,setIsDelete] = useState(false)
  const [openHoldPopup, setOpenHoldPopup] = useState(false);
  const [deleteId,setDeleteId] = useState(null);
   const [deleteTeam, setDeleteTeam] = useState(false);
     const [anchorEl, setAnchorEl] = useState(null);
     const [setectedRow, setSelectedRow] = useState(null);
       const [holdReason, setHoldReason] = useState('');
       const [isSubmittingHold, setIsSubmittingHold] = useState(false);
       const [holdReasonError, setHoldReasonError] = useState('');
       const [expandedInvoiceGroupIds, setExpandedInvoiceGroupIds] = useState([]);
       const [listUngroupSelections, setListUngroupSelections] = useState({});
     console.log('setectedRow=====================', setectedRow)
  let userData = JSON.parse(localStorage.getItem('user'))
  let userType = userData.user_type
  const explodedPermissions =userData?.exploded_permissions
  const handleClose = () => {
    setAnchorEl(null);
  };
const TABLE_HEAD = [
      { id: 'id', label:  'ID', alignRight: false },
      { id: 'name', label:  'Name', alignRight: false },
     ...(
    estimate && proposalView
      ? [{ id: 'date', label: 'Created', alignRight: false }]
      : estimate && installsJobs
        ? [
            { id: 'project', label: 'Project', alignRight: false },
          ]
      : estimate
        ? [
            { id: 'project', label: 'Project', alignRight: false },
            { id: 'client', label: 'Client', alignRight: false },
          ]
        : []
  ),
    ...(noImage && !estimate ? [{ id: 'rush', label: '', alignRight: false }] : []),
      { id: 'status', label: 'Status', alignRight: false },
    ...(estimate && proposalView && isAdminUser (userData.user_type)
      ? [{ id: 'proposal_actions', label: 'Actions', alignRight: false }]
      : []),
    ...(userData.user_type === 3
      ? []
      : [{ id: 'options', label: 'Options', alignRight: false, disableSort: true }]),
  ];
  const TABLE_HEAD2 = [
      { id: 'id', label:  'ID', alignRight: false },
    { id: 'image', label: 'Profile Image', alignRight: false },
    { id: 'name', label: 'Name', alignRight: false },
      ...(
    estimate && proposalView
      ? [{ id: 'date', label: 'Created', alignRight: false }]
      : estimate
        ? [
            { id: 'project', label: 'Project', alignRight: false },
          ]
        : []
  ),
    { id: 'status', label: 'Status', alignRight: false },
    ...(estimate && proposalView && isAdminUser (userData.user_type)
      ? [{ id: 'proposal_actions', label: 'Actions', alignRight: false }]
      : []),
    ...(userData.user_type === 3
      ? []
      : [{ id: 'options', label: 'Options', alignRight: false, disableSort: true }]),
  ];
  const invoiceGroupPrefixColumns = [];
  if (enableInvoiceGroupAccordion) {
    invoiceGroupPrefixColumns.push({ id: 'expand', label: '', alignRight: false });
  }
  if (isInvoiceListGroupingEnabled) {
    invoiceGroupPrefixColumns.push({ id: 'select', label: '', alignRight: false });
  }
  const activeTableHead = [...invoiceGroupPrefixColumns, ...(noImage ? TABLE_HEAD : TABLE_HEAD2)];
    const getStatusColorAndLabel = (status) => {
  switch (status) {
    case 1:
      return { 
        color: 'primary',
        //  label: 'Status: Open'
         label: ' Open'
         }
    default:
      return { color: 'default', label: 'Pending' }
  }
}

  // Same status conditions as OfficialCard.js (list view only)
  const getStatusColorAndLabelSales = (row) => {
    const status = row?.status != null ? Number(row.status) : row?.status;
    const installationStatus = row?.installationStatus;
    const allInstallationCompleted = row?.allInstallationCompleted;
    const accepted = row?.installation_acceptance;
    const min_payment_status = row?.min_payment_status;
    const billing_type = row?.billing_type;
    const noServiceNoTask = row?.noServiceNoTask ?? row?.proj_noServiceNoTask;
    const proj_status = row?.proj_status;
    const job_category_name = row?.job_category_name;
    const partial_install = row?.partial_install;
    const new_order = row?.new_order;
    const for_parent_facility = row?.for_parent_facility;
    const split_mirror_status = row?.split_mirror_status;
    const received_status = row?.received_status;
    const hold = row?.hold;
    const project_category = row?.project_category;
    const installation_pending_review = row?.installation_pending_review;
    const isReview = row?.isReview;
    const installationCompleteStatus = row?.installationCompleteStatus;
    const mixed_installation = row?.mixed_installation;
    const is_scheduled = row?.is_scheduled;

    const CompletedStatus =
      mixed_installation == 1 ? 'Mixed Installations' :
      (installationCompleteStatus == 1 || split_mirror_status == 1)
        ? 'Installation'
        : (installationCompleteStatus == 2 || split_mirror_status == 2)
        ? received_status == 1 ? 'Picked Up' : 'Pick up'
        : CommunityJob
        ? 'Installation'
        : (installationCompleteStatus == 3 || split_mirror_status == 3)
        ? received_status == 1 ? 'Shipped' : 'Shipping'
        : '';

    if ((new_order === 1 && [2, 3, 4].includes(status) && hold == 0)) {
      return { color: 'info', label: 'New' };
    }
    if (split_mirror_status == 7 && status == 3 && hold == 0) {
      return { color: 'warning', label: 'Awaiting Approval' };
    }
    switch (status) {
      case 1:
        return { color: 'warning', label: 'Draft' };
      case 2:
        return {
          color: hold == 1 ? 'warning' : 'warning',
          label: hold == 1 ? 'Hold' : min_payment_status == 0 ? 'Awaiting Approval and Payment Due' : 'Awaiting Approval',
        };
      case 3:
        return {
          color: `${
            hold === 1 ? 'warning' :
            project_category == 13
              ? 'primary'
              : min_payment_status == 0
              ? 'warning'
              : 'primary'
          }`,
          label: `${
            hold === 1 ? 'Hold' :
            project_category == 13 || billing_type == 0
              ? 'Approved'
              : min_payment_status == 1
              ? 'Approved'
              : 'Approved and Payment Due'
          }`,
        };
      case 4: {
        const isInstallationPendingReview = Number(installation_pending_review) === 1 && !empty(allInstallationCompleted) && empty(accepted);
        const isInstallationCompletedAndNotPublished = Number(installation_pending_review) === 2 && !empty(allInstallationCompleted) && empty(accepted);
        return {
          color: hold == 1 ? 'warning' : (noServiceNoTask == 1 && proj_status == 3) ? 'success' :
            isInstallationCompletedAndNotPublished ? 'success' :
            (isReview == 2 && (!empty(allInstallationCompleted))) || isInstallationPendingReview ? 'warning' :
            split_mirror_status == 8 ? 'success' :
            min_payment_status == 0 ? 'warning' :
            empty(accepted) && (!empty(allInstallationCompleted && split_mirror_status !== 1 && split_mirror_status !== 2 && split_mirror_status !== 3 && split_mirror_status !== 5 && received_status !== 1) || split_mirror_status == 4)
              ? 'warning'
              : 'success',
          label: hold == 1 ? 'Hold' : (noServiceNoTask == 1 && proj_status == 3 && project_category !== 12) ? 'No Service No Task' :
            (isReview == 2 && (!empty(allInstallationCompleted))) ? 'Completed & Awaiting Review' : isInstallationCompletedAndNotPublished ? 'Installation' : isInstallationPendingReview ? 'Installation In Review' :
            split_mirror_status == 8 ? 'Production' :
            empty(accepted) && ((!empty(allInstallationCompleted && split_mirror_status !== 1 && split_mirror_status !== 2 && split_mirror_status !== 3 && split_mirror_status !== 5 && received_status !== 1) || split_mirror_status == 4))
              ? allInstallationCompleted ? `${CompletedStatus} Completed & Awaiting approval` : received_status == 1 ? `${CompletedStatus}` : 'Completed & Awaiting approval'
              : (job_category_name === 'Build Order' && status === 4 && accepted === 1) ? 'Completed'
              : ((!empty(accepted) && (!empty(allInstallationCompleted))) || split_mirror_status == 5)
              ? allInstallationCompleted ? `${CompletedStatus} Completed & Approved` : 'Completed & Approved'
              : !empty(installationStatus)
              ? partial_install == 1 ? 'Partially Installed' : (proj_status != 3 && is_scheduled == 1) ? 'Production' : (proj_status != 3 && installationStatus) ? 'Partial Install' : (proj_status != 3) ? 'Production' : min_payment_status == 0 ? `Payment Due for ${CompletedStatus}` : `${CompletedStatus}`
              : CommunityJob ? `${CompletedStatus} Completed & Approved` :
              (for_parent_facility == 2 && (split_mirror_status !== 0 && split_mirror_status !== 6)) ? (min_payment_status == 0 ? `Payment Due for ${CompletedStatus}` : `${CompletedStatus}`) : 'Production',
        };
      }
      case 5:
        return { color: 'warning', label: 'Closed' };
      case 6:
        return { color: 'error', label: 'Rejected' };
      case 10:
        return { color: 'error', label: 'Void' };
      default:
        return { color: 'default', label: 'Open' };
    }
  };

  const tableColumnCount = activeTableHead.length;
  const invoiceGroupParentRowSx = {
    backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 166, 231, 0.08)' : 'rgba(0, 166, 231, 0.16)',
    boxShadow: `inset 4px 0 0 ${theme.palette.primary.main}`,
    '& .MuiTableCell-root': {
      padding: '8px 12px',
      fontSize: '0.75rem',
      height: 'auto',
      lineHeight: 1.4,
      borderTop: `1px solid ${theme.palette.primary.main}`,
      borderBottom: `1px solid ${theme.palette.divider}`,
      fontWeight: 600,
    },
  };
  const getGroupedSalesOrderNamesText = (row) => (
    (row?.grouped_requests || [])
      .map((child) => child?.name)
      .filter(Boolean)
      .join(', ') || 'Unknown Orders'
  );
  const getGroupedInvoiceDisplayName = (row) => {
    // This change ensures that the updated grouped invoice name is displayed on the card, preventing a mismatch between the card and the view page.
    if (row?.name && !String(row.name).startsWith('Combined Sales Orders')) {
      return row.name;
    }
    const count = row?.grouped_quantity
      || String(row?.grouped_request_ids || '').split(',').filter(Boolean).length
      || row?.grouped_requests?.length
      || 0;
    return `Combined Sales Orders (${count}) - ${getGroupedSalesOrderNamesText(row)}`;
  };
  const isSyncedWithQuickbooks = (rowData) => Number(rowData?.syncWithQuickbooks) === 1;
  const getQuickbooksJobDocNumber = (rowData) => (
    isSyncedWithQuickbooks(rowData) ? rowData?.est_doc_number || null : null
  );
  const getQuickbooksInvoiceDocNumber = (rowData) => {
    if (!isSyncedWithQuickbooks(rowData)) return null;
    const docNumber = rowData?.doc_number;
    if (!docNumber || String(docNumber) === String(rowData?.id)) return null;
    return docNumber;
  };
  const hasQuickbooksDisplayNumbers = (rowData) => !!(
    getQuickbooksJobDocNumber(rowData) || getQuickbooksInvoiceDocNumber(rowData)
  );
  const getGroupedJobNumbers = (row) => (
    (row?.grouped_requests || [])
      .map((child) => getQuickbooksJobDocNumber(child) || getQuickbooksInvoiceDocNumber(child))
      .filter(Boolean)
  );
  const getGroupedJobNumbersText = (row) => getGroupedJobNumbers(row).join(', ');
  const handleOpenGroupedInvoiceDetails = (groupRow) => {
    handleOpenDetailsSalesOrder?.(groupRow?.id, getGroupedInvoiceDisplayName(groupRow), false, true);
  };
  const getSalesOrderStatusSource = (row) => (
    row?.grouped_requests?.[0] ? { ...row, ...row.grouped_requests[0] } : row
  );
  const hasActiveUngroupSelection = Object.values(listUngroupSelections).some((ids) => ids?.length > 0);
  const isCombineSelectionLocked = expandedInvoiceGroupIds.length > 0 || hasActiveUngroupSelection;
  const shouldShowCombineCheckboxForRow = (row) => (
    !isCombineSelectionLocked && canShowInvoiceGroupCheckbox?.(row)
  );
  const toggleInvoiceGroupExpand = (groupId) => {
    setExpandedInvoiceGroupIds((prev) => {
      const isClosing = prev.includes(groupId);
      if (isClosing) {
        setListUngroupSelections((selections) => {
          const next = { ...selections };
          delete next[groupId];
          return next;
        });
        return prev.filter((id) => id !== groupId);
      }
      onClearInvoiceGroupSelection?.();
      return [...prev, groupId];
    });
  };
  const toggleListUngroupSelection = (parentId, childId) => {
    setListUngroupSelections((prev) => {
      const current = prev[parentId] || [];
      const isRemoving = current.includes(childId);
      const next = isRemoving
        ? current.filter((id) => id !== childId)
        : [...current, childId];
      if (!isRemoving && current.length === 0) {
        onClearInvoiceGroupSelection?.();
      }
      return { ...prev, [parentId]: next };
    });
  };
  const renderListPrefixCells = (row) => (
    <>
      {enableInvoiceGroupAccordion && (
        <TableCell sx={{ width: 48, p: 0.5 }} />
      )}
      {isInvoiceListGroupingEnabled && (
        <TableCell padding="checkbox" sx={{ width: 48 }}>
          {shouldShowCombineCheckboxForRow(row) ? (
            <Checkbox
              size="small"
              checked={selectedInvoiceGroupIds.includes(row.id)}
              onChange={() => onToggleInvoiceGroupSelection?.(row)}
            />
          ) : null}
        </TableCell>
      )}
    </>
  );
  const renderImageCell = (imageUrl, altText) => (
    <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
      <img
        src={imageUrl}
        style={{
          width: '40px',
          height: '40px',
          borderRadius: '5px',
          margin: '0 auto',
          display: 'block',
          objectFit: 'fill',
        }}
        alt={altText}
      />
    </TableCell>
  );
  const renderGroupedChildPrefixCells = (parentId, childRow, selectedUngroupIds) => (
    <>
      {enableInvoiceGroupAccordion && <TableCell sx={{ width: 48, p: 0.5 }} />}
      {isInvoiceListGroupingEnabled && (
        <TableCell padding="checkbox" sx={{ width: 48 }}>
          <Checkbox
            size="small"
            checked={selectedUngroupIds.includes(childRow.id)}
            onChange={() => toggleListUngroupSelection(parentId, childRow.id)}
          />
        </TableCell>
      )}
    </>
  );
  const QB_LOGO_WIDTH = 44;
  const QB_LOGO_HEIGHT = 22;
  const renderSalesOrderListIdCell = (rowData, invoiceSequenceIndex = null) => (
    <TableCell align="left">
      {(() => {
        const invoiceSequenceSuffix = invoiceSequenceIndex ? ` - ${invoiceSequenceIndex}` : '';
        const estDocNumber = getQuickbooksJobDocNumber(rowData);
        const invoiceDocNumber = getQuickbooksInvoiceDocNumber(rowData);
        const hasJobAndInvoice = estDocNumber
          && invoiceDocNumber
          && String(invoiceDocNumber) !== String(estDocNumber);
        if (!hasQuickbooksDisplayNumbers(rowData)) {
          return '';
        }
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 0.75 }}>
            <img
              src={quickbookLogo}
              alt="QuickBooks"
              width={QB_LOGO_WIDTH}
              height={QB_LOGO_HEIGHT}
              style={{ objectFit: 'contain', display: 'block', flexShrink: 0 }}
            />
            <Box sx={{ textAlign: 'left' }}>
              {(rowData?.installation_acceptance && estDocNumber) && hasJobAndInvoice ? (
                <>
                  <Typography sx={{ fontSize: '0.75rem', color: theme.palette.mode === 'light' ? '#53aa00' : '#90EE90', textAlign: 'left' }}>
                    {`Job: #${estDocNumber}`}
                  </Typography>
                  <Typography sx={{ fontSize: '0.75rem', color: theme.palette.mode === 'light' ? '#53aa00' : '#90EE90', textAlign: 'left' }}>
                    {`Inv: #${invoiceDocNumber}${invoiceSequenceSuffix}`}
                  </Typography>
                </>
              ) : (
                <Typography sx={{ fontSize: '0.75rem', color: theme.palette.mode === 'light' ? '#53aa00' : '#90EE90', textAlign: 'left' }}>
                  {estDocNumber
                    ? `Job: #${estDocNumber}${invoiceSequenceSuffix}`
                    : invoiceDocNumber
                      ? `#${invoiceDocNumber}${invoiceSequenceSuffix}`
                      : ''}
                </Typography>
              )}
            </Box>
          </Box>
        );
      })()}
    </TableCell>
  );
  const renderSalesOrderListNameCell = (rowData) => (
    <TableCell
      align="left"
      sx={{
        fontSize: '0.75rem',
        cursor: 'pointer',
        '&:hover': { textDecoration: 'underline' },
      }}
      onClick={() => handleOpenDetailsSalesOrder(rowData?.id, rowData?.name)}
    >
      {rowData?.name}
    </TableCell>
  );
  const renderSalesOrderListDetailsCell = (rowData) => (
    <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
      <Button
        onClick={() => handleOpenDetailsSalesOrder(rowData?.id, rowData?.name)}
        variant="subtitle1"
        sx={{
          mt: 0,
          p: 0,
          minWidth: 0,
          fontSize: '0.75rem',
          color: theme.palette.primary.main,
        }}
      >
        Details
      </Button>
    </TableCell>
  );
  const renderGroupedInvoiceParentIdCell = (groupRow) => {
    const groupedJobNumbersText = getGroupedJobNumbersText(groupRow);
    if (!groupedJobNumbersText) {
      return <TableCell align="left" />;
    }
    return (
      <TableCell align="left">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 0.75 }}>
          <img
            src={quickbookLogo}
            alt="QuickBooks"
            width={QB_LOGO_WIDTH}
            height={QB_LOGO_HEIGHT}
            style={{ objectFit: 'contain', display: 'block', flexShrink: 0 }}
          />
          <Tooltip title={`Job: #${groupedJobNumbersText}`}>
            <Typography
              sx={{
                fontSize: '0.75rem',
                color: theme.palette.mode === 'light' ? '#53aa00' : '#90EE90',
                maxWidth: 120,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                textAlign: 'left',
              }}
            >
              {`Job: #${groupedJobNumbersText}`}
            </Typography>
          </Tooltip>
        </Box>
      </TableCell>
    );
  };
  const renderGroupedInvoiceOrderCountCell = (groupRow) => {
    const count = groupRow?.grouped_quantity || groupRow?.grouped_requests?.length || 0;
    return (
      <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
        <Button
          onClick={() => handleOpenGroupedInvoiceDetails(groupRow)}
          size="small"
          sx={{
            mt: 0,
            px: 1.5,
            py: 0.25,
            minWidth: 0,
            fontSize: '0.75rem',
            fontWeight: 600,
            lineHeight: 1.4,
            textTransform: 'none',
            color: theme.palette.primary.main,
            borderRadius: '999px',
            backgroundColor: theme.palette.mode === 'light'
              ? 'rgba(0, 166, 231, 0.12)'
              : 'rgba(0, 166, 231, 0.2)',
            '&:hover': {
              backgroundColor: theme.palette.mode === 'light'
                ? 'rgba(0, 166, 231, 0.2)'
                : 'rgba(0, 166, 231, 0.28)',
            },
          }}
        >
          {count} Orders
        </Button>
      </TableCell>
    );
  };
  const invoiceGroupChildRowSx = {
    backgroundColor: theme.palette.action.hover,
    boxShadow: `inset 4px 0 0 ${theme.palette.primary.main}`,
    '& .MuiTableCell-root': {
      padding: '8px 12px',
      fontSize: '0.75rem',
      height: 'auto',
      lineHeight: 1.4,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  };
  const renderInvoiceGroupChildRow = (parentId, childRow, selectedUngroupIds, childIndex) => {
    const childAttachments = childRow?.attachment?.filter(
      (imageItem) => imageItem?.file_type?.startsWith('image') || imageItem?.file_type === 'img',
    ) || [];
    const childImage = childAttachments?.[0]?.name
      || (childRow?.customer_pic && childRow?.customer_pic !== 'avatar.jpg' ? childRow.customer_pic : COMPANY_LOGO);

    return (
      <TableRow hover key={`group-child-${childRow.id}`} sx={invoiceGroupChildRowSx}>
        {renderGroupedChildPrefixCells(parentId, childRow, selectedUngroupIds)}
        {renderSalesOrderListIdCell(childRow, (childIndex || 0) + 1)}
        {!noImage && !installsJobs && renderImageCell(childImage, childRow?.name)}
        {estimate ? renderSalesOrderListNameCell(childRow) : (

          <TableCell align="left" sx={{ fontSize: '0.75rem' }}>{childRow?.name}</TableCell>
        )}
        {noImage && !estimate && <TableCell />}
        {estimate && renderProjectLabelCell(childRow?.community_name)}
        {noImage && !installsJobs && renderClientLabelCell(childRow?.customer_name)}
        {estimate && renderSalesOrderStatusCell(childRow)}
        {estimate && renderSalesOrderListDetailsCell(childRow)}
      </TableRow>
    );
  };
  const renderProjectLabelCell = (communityName) => (
    <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
      {communityName ? (
        <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="warning">
          <Tooltip title={communityName}>
            <Typography
              variant="subtitle2"
              sx={{
                fontSize: '0.75rem',
                display: 'inline-block',
                maxWidth: 80,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {communityName}
            </Typography>
          </Tooltip>
        </Label>
      ) : (
        <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="error">
          No project
        </Label>
      )}
    </TableCell>
  );
  const renderClientLabelCell = (customerName) => (
    <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
      <Label variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'} color="secondary">
        <Tooltip title={customerName}>
          <Typography
            variant="subtitle2"
            sx={{
              fontSize: '0.75rem',
              display: 'inline-block',
              maxWidth: 150,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {customerName}
          </Typography>
        </Tooltip>
      </Label>
    </TableCell>
  );
  const renderSalesOrderStatusCell = (row, groupedStatusOverride = null) => (
    <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
      {(() => {
        const statusInfo = groupedStatusOverride || getStatusColorAndLabelSales(row);
        return (
      <Label
        variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
        color={statusInfo.color}
      >
        {statusInfo.label}
      </Label>
        );
      })()}
    </TableCell>
  );
  const renderInvoiceGroupAccordionRows = (row) => {
    const isExpanded = expandedInvoiceGroupIds.includes(row.id);
    const statusSource = getSalesOrderStatusSource(row);
    const selectedUngroupIds = listUngroupSelections[row.id] || [];
    const groupedStatusOverride =
      currentTab === 'INVOICING'
        ? { color: 'warning', label: 'Grouped Completed & Waiting For Approval' }
        : currentTab === 'COMPLETED'
          ? { color: 'success', label: 'Grouped Completed & Approved' }
          : null;
    const firstChild = row?.grouped_requests?.[0];
    const filteredAttachments = firstChild?.attachment?.filter(
      (imageItem) => imageItem?.file_type?.startsWith('image') || imageItem?.file_type === 'img',
    ) || [];
    const groupImage = filteredAttachments?.[0]?.name
      || (firstChild?.customer_pic && firstChild?.customer_pic !== 'avatar.jpg' ? firstChild.customer_pic : COMPANY_LOGO);

    return [
      <TableRow hover key={`group-${row.id}`} sx={invoiceGroupParentRowSx}>
        <TableCell sx={{ width: 48, p: 0.5 }}>
          <IconButton size="small" onClick={() => toggleInvoiceGroupExpand(row.id)}>
            <Icon icon={isExpanded ? arrowIosUpwardFill : arrowIosDownwardFill} width={18} height={18} />
          </IconButton>
        </TableCell>
        {isInvoiceListGroupingEnabled && (
          <TableCell padding="checkbox" sx={{ width: 48 }}>
            {!isExpanded && shouldShowCombineCheckboxForRow(row) ? (
              <Checkbox
                size="small"
                checked={selectedInvoiceGroupIds.includes(row.id)}
                onChange={() => onToggleInvoiceGroupSelection?.(row)}
              />
            ) : null}
          </TableCell>
        )}
        {renderGroupedInvoiceParentIdCell(row)}
        {!noImage && !installsJobs && renderImageCell(groupImage, getGroupedInvoiceDisplayName(row))}
        <TableCell
          align="left"
          sx={{
            fontSize: '0.75rem',
            cursor: 'pointer',
            '&:hover': { textDecoration: 'underline' },
          }}
          onClick={() => handleOpenGroupedInvoiceDetails(row)}
        >
          {getGroupedInvoiceDisplayName(row)}
        </TableCell>
        {noImage && !estimate && <TableCell />}
        {estimate && renderProjectLabelCell(row?.community_name)}
        {noImage && !installsJobs && renderClientLabelCell(row?.customer_name)}
        {estimate && renderSalesOrderStatusCell(statusSource, groupedStatusOverride)}
        {estimate && renderGroupedInvoiceOrderCountCell(row)}
      </TableRow>,
      ...(isExpanded ? [
        <TableRow key={`group-toolbar-${row.id}`} sx={invoiceGroupChildRowSx}>
          <TableCell
            colSpan={tableColumnCount}
            sx={{
              mt: 1.5,
              py: 1.5,
              px: 2,
              borderTop: `1px solid ${theme.palette.primary.main}`,
              borderBottom: `1px solid ${theme.palette.primary.main}`,
            }}
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'flex-start', sm: 'center' }}
              justifyContent="space-between"
              spacing={1}
            >
              <Typography variant="subtitle2">
                Combined Sales Orders
                {selectedUngroupIds.length > 0 ? ` - Selected: ${selectedUngroupIds.length}` : ''}
              </Typography>
              {selectedUngroupIds.length > 0 && (
                <Stack direction="row" spacing={1}>
                  <Button
                    size="small"
                    variant="outlined"
                    startIcon={<Icon icon={closeFill} width={16} height={16} />}
                    onClick={() => setListUngroupSelections((prev) => ({ ...prev, [row.id]: [] }))}
                    disabled={ungroupingInvoiceRequests}
                  >
                    Clear
                  </Button>
                  <LoadingButton
                    size="small"
                    variant="contained"
                    color="error"
                    loading={ungroupingInvoiceRequests}
                    loadingPosition="start"
                    startIcon={<CallSplit sx={{ width: 16, height: 16 }} />}
                    onClick={async () => {
                      await onUngroupInvoiceRequests?.(row.id, selectedUngroupIds);
                      setListUngroupSelections((prev) => ({ ...prev, [row.id]: [] }));
                    }}
                  >
                    Ungroup Selected
                  </LoadingButton>
                </Stack>
              )}
            </Stack>
          </TableCell>
        </TableRow>,
        ...(row?.grouped_requests || []).map((childRow, childIndex) => (
          renderInvoiceGroupChildRow(row.id, childRow, selectedUngroupIds, childIndex)
        )),
      ] : []),
    ];
  };
  const getStatusColorAndLabelDesignOrder = (status, hold, design_order_job_status, send_client_app_req, attachment_count, attachment, is_in_queue) => {
    // HOLD: hold=1 AND status !=0
    if (hold == 1 && status != 0) {
      return {
        color: 'warning',
        label: 'Hold',
      }
    }
    
    // REJECTED: status=6 AND hold=0
    if (status == 6 && hold == 0) {
      return {
        color: 'error',
        label: 'Rejected',
      }
    }
    
    // APPROVED: status=2 AND hold=0
    if (status == 2 && hold == 0) {
      return {
        color: 'success',
        label: 'Approved',
      }
    }
    
    // DESIGN JOB COMPLETED: design_order_job_status = 3 AND send_client_app_req=0 AND status !=0 AND hold = 0
    if (design_order_job_status == 3 && send_client_app_req == 0 && status != 0 && hold == 0) {
      return {
        color: 'success',
        label: 'Review/Send for Approval',
      }
    }
    
    // Same as ViewDesignOrderDetails (array length, no isDesign filter)
  // previously: // const hasDesignAttachments = attachment_count > 0 || (attachment && attachment.length > 0 && attachment.some(att => att?.isDesign == 1));
    const hasDesignAttachments = attachment && Array.isArray(attachment) && attachment.length > 0;
    
    // For status 1, check conditions in priority order
    if (status == 1 && hold == 0) {
      // AWAITING APPROVAL: status=1 AND hold=0 AND send_client_app_req=1
      // List payload clears attachment for status != 2, so don't require hasDesignAttachments here
      if (send_client_app_req == 1) {
        return {
          color: 'warning',
          label: 'Awaiting Approval',
        }
      }
      
      // IN DESIGN: doa.id IS NOT NULL AND status = 1 AND hold = 0 AND send_client_app_req=0 AND design_order_job_status != 3
      // if (send_client_app_req == 0 && design_order_job_status != 3 && hasDesignAttachments) {
      if (send_client_app_req == 0 && design_order_job_status == 2) {
        return {
          color: 'info',
          label: 'In Design',
        }
      }
      
      // NEW: status=1 AND hold=0 AND doa.id IS NULL AND design_order_job_status != 3 AND send_client_app_req=0
      // if (!hasDesignAttachments && design_order_job_status != 3 && send_client_app_req == 0) {
      if (send_client_app_req == 0 && (design_order_job_status == 1 || design_order_job_status==7 )&& is_in_queue == 1) {
        return {
          color: 'info',
          label: 'In Queue',
        }
      }
      if (send_client_app_req == 0 && design_order_job_status == 1 && is_in_queue == 0) {
        return {
          color: 'info',
          label: 'New',
        }
      }
      
      // Default fallback for status 1
      return {
        color: 'info',
        label: 'Open',
      }
    }
    
    // Other status cases
    switch (status) {
      case 3:
        return {
          color: hold == 1 ? 'warning' : 'success',
          label: hold == 1 ? 'Hold' : 'Approved',
        }
      case 4:
        return {
          color: hold == 1 ? 'warning' : 'warning',
          label: hold == 1 ? 'Hold' : 'Draft',
        }
      case 5:
        return {
          color: hold == 1 ? 'warning' : 'warning',
          label: hold == 1 ? 'Hold' : 'Closed',
        }
      default:
        return {
          color: hold == 1 ? 'warning' : 'default',
          label: hold == 1 ? 'Hold' : 'Open',
        }
    }
  }

  const handleUpdateSalesOrderHoldStatus = async (reason,id) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}sales_order/update-sales-order-hold-status`,
        {
          request_id: Number(id),
          userId: user.user_id,   
          reason: reason || '',
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRenderCards(!renderCards);
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };
    const handleUpdateHoldStatus = async (reason,id) => {
      try {
        const user = JSON.parse(window.localStorage.getItem('user'));
        const res = await axios.post(
          `${REST_API_END_POINT}project/update-design-order-job-hold-status`,
          {
            projectId: Number(id),
            userId: user.user_id,
            reason: reason || '',
            designOrder: true,
          },
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );
        if (res.data.status === 1) {
          enqueueSnackbar(res.data.message, { variant: 'success' });
          setRenderCards(!renderCards);
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' });
        }
      } catch (error) {
        console.error('Error updating hold status:', error);
      }
    };

  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  // Rest of the code remains unchanged from here
  // ...
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = UsersListV.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };


  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  const emptyRows = projectData.length > 0 ? 0 : 2;
  
  const isUserNotFound = projectData?.length === 0;
  const handleClickOpenViewPage=(id,name)=>{
    setProjectId(id)
    setProjectName(name)
    setOpenViewPage(true)
    localStorage.setItem("openProductionPopup", "true");
    localStorage.setItem("projectId", id);
    localStorage.setItem("projectName", name);
    
    // setSearchParams({
    //   open: "true",
    //   // view: "viewPage",
    //   // projectId: id,
    //   // projectName: name,
    // });
  }
  const changeStatus = async (teamId, teamStatus) => {
    try {
      let status = teamStatus;
      let userId = userData.user_id
    
      let response = await axios.post(`${REST_API_END_POINT}teams/delete-team-members`,
        { teamId, status, userId },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        })
    
      if (response.data.status === 1) {
        setDeleteId('');
        enqueueSnackbar(response.data.message, { variant: 'success' });
        navigate(PATH_DASHBOARD.callCenter.teams, { state: { data: teamId } });
      }
      else if (response.data.status === 0) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
      else {
       
        enqueueSnackbar("Error.........!", { variant: 'error' });
      }
    }
    catch (error) {
      console.log("Delete error : ", error);
    }
  }
   const handleDeleteClient=async(id,status)=>{
     try {
      const data={id:id,status:status}
      const res = await axios.post(`${REST_API_END_POINT}clients/remove-client`,data)
      console.log(res.data)
       if(res.data.status ==1){
        setDeleteId('');
        setDeleteTeam(false);
        setRefreshClient((prev)=>!prev)
       enqueueSnackbar(res.data.message,{variant:'success'})
       }else if(res.data.status ==0){
        setDeleteId('');
        enqueueSnackbar(res.data.message,{variant:'error'})
       }
     } catch (error) {
       console.log(error,'Error in deleting client')
     }
   }
const canViewQuotation = (row) => {
  // if (row?.quotation_status === 6) return false;
  if (userType === 3 && row?.accept_status === 2) return false;

  if ((row?.quotation_status === 4 && row?.quotation === 0) || userType === 3) {
    return (
      explodedPermissions?.some((permission) =>
        ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
      ) || (userType === 3 && row?.status !== 6)
    );
  } else {
    return (
      explodedPermissions?.some((permission) =>
        ['Edit Estimate'].includes(permission)
      ) || (userType === 3 && row?.status !== 6)
    );
  }
};

const canEditQuotation = (row) => {
  return (
    row?.quotation_status !== 6 &&
    (
      explodedPermissions?.some((permission) =>
        ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
      ) || (userType === 3 && row?.status !== 6)
    ) &&
    !(userType === 3 && row?.accept_status === 2)
  );
};
const handleQuotationNameClick = (row) => {
  if (!canViewQuotation(row)) {
    enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
    return;
  }
  if ((row?.quotation_status === 4 && row?.quotation === 0) || userType === 3) {
    handleOpenDetails(row?.id, row?.name);
  } else {
    // handleOpenViewEstimate(row?.id, row?.name);
    handleOpenDetails(row?.id, row?.name);
  }
};

const handleQuotationEditClick = (row) => {
  if (canEditQuotation(row)) {
    handleOpenDetails(row?.id, row?.name);
  } else {
    enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
  }
};






  return (
<>
      <Grid container spacing={3}>
     
          <Grid item xs={12}>
            <Card>
              {/* <ProjectListViewToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}
  
              <Scrollbar>
                <TableContainer 
                  ref={tableScrollRef}
                  sx={{ 
                    minWidth: 800,
                    ...(invoiceGroupActionBarVisible ? { mt: 2 } : {}),
                    whiteSpace: "nowrap", 
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: tableMaxHeight,
                    '&::-webkit-scrollbar': {
                      width: '0.6em',
                      height: '0.6em',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#1e1e1e', // dark background to blend with dark UI
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#555', // medium-gray thumb
                      borderRadius: '6px',
                      border: '2px solid #1e1e1e', // contrast border to separate from track
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#888', // lighter on hover for feedback
                    },
                    '&::-webkit-scrollbar-corner': {
                      backgroundColor: '#1e1e1e' // match your dark background
                    },
                  }}
                >
                  <Table 
                    stickyHeader
                    size="small"
                    sx={{
                      tableLayout: estimate ? 'auto' : undefined,
                      '& .MuiTableCell-head': {
                       
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        height: '48px',
                        minHeight: '48px',
                        maxHeight: '48px',
                        lineHeight: 1.4,
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                        verticalAlign: 'middle'
                      },
                      '& .MuiTableSortLabel-root': {
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        justifyContent: 'flex-start',
                        '& .MuiTableSortLabel-icon': {
                          marginLeft: '4px'
                        }
                      }
                    }}
                  >
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={activeTableHead}
                      rowCount={projectData?.length}
                      numSelected={selected?.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                      checkboxPresent={true}
                      
                    />
                  <TableBody>
                    {projectData?.flatMap((row) => {
                      if (enableInvoiceGroupAccordion && Number(row?.is_grouped_request || 0) === 1) {
                        return renderInvoiceGroupAccordionRows(row);
                      }
                      const { id, name, accept_status, community_name,participation_ends,installation_start_date,installation_end_date,attachment,customer_pic } = row
                      const status = Number(row?.status)
                      const hold = Number(row?.hold)
                      const filteredAttachments = designOrder
    ? attachment?.filter(imageItem=>(imageItem?.isDesign == 1 && (imageItem?.file_type?.startsWith("image") || imageItem?.file_type === "img"))) || []
    : attachment?.filter(imageItem=>(imageItem?.file_type?.startsWith("image") || imageItem?.file_type === "img")) || []
                      // let Newimage = COMPANY_LOGO
                      let Newimage = filteredAttachments?.[0]?.name
                                      ? filteredAttachments[0].name
                                      : customer_pic && customer_pic !== 'avatar.jpg'
                                      ? customer_pic
                                      : COMPANY_LOGO
                      const Newname = row?.name;
                      const isSalesOrderNew = salesOrder && !!row?.is_new_in_tab
                      const salesOrderStatusMeta = salesOrder
                        ? getStatusColorAndLabelSales(row)
                        : null;

                      return [
                        <TableRow
                          hover
                          key={row?.id}
                          sx={{
                            '& .MuiTableCell-root': {
                              padding: '8px 12px',
                              fontSize: '0.75rem',
                              height: 'auto',
                              lineHeight: 1.4
                            },
                            ...getSalesOrderNewRowSx(theme, isSalesOrderNew),
                          }}
                        >
                                                    {/* <TableCell padding="checkbox">
                              <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, name)} />
                            </TableCell> */}

                          {/* <TableCell align="right">
                                    <Box sx={{ width: '100%', display: "flex", justifyContent: "center", height: "30px",width:"50px", mt: 2 }}>
                                        {
                                            row?.syncWithQuickbooks ?
                                                <img src={quickbookLogo} width={"50px"} height={"30px"} />
                                                : ""
                                        }
                                    </Box>
                                </TableCell> */}
                          {renderListPrefixCells(row)}
                          {isDesign ? (
                            <TableCell align="left">
                              {/* <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.5} flexWrap="wrap"> */}
                              <Typography sx={{ fontSize: '0.75rem', color: theme.palette.mode === 'light' ? '#53aa00' : '#90EE90' }}>
                                {row?.id ? `#${row?.id}` : ''}
                              </Typography>
                              {/* :
                            (row?.installation_acceptance && row?.est_doc_number) && (row?.doc_number !== row?.est_doc_number) ?
                              <>
                                <Typography sx={{ fontSize: '0.75rem', color:theme.palette.mode === 'light' ? "#53aa00" : "#90EE90" }}>
                                  {row?.est_doc_number ? `Job: #${row?.est_doc_number}` : ''}
                                </Typography>
                                <Typography sx={{ fontSize: '0.75rem', color:theme.palette.mode === 'light' ? "#53aa00" : "#90EE90" }}>
                                  {row?.doc_number ? `Inv: #${row?.doc_number}` : ''}
                                </Typography>
                              </>
                              :
                              <Typography sx={{ fontSize: '0.75rem', color:theme.palette.mode === 'light' ? "#53aa00" : "#90EE90" }}>
                                {estimate
                                  ? (row?.est_doc_number ? `#${row.est_doc_number}` : row?.doc_number ? `#${row.doc_number}` : row?.id ? `#${row.id}` : '')
                                  : (row?.doc_number ? `#${row?.doc_number}` : '')}
                              </Typography> */}
                                {isSalesOrderNew && (
                              <SalesOrderNewBadgeList>NEW</SalesOrderNewBadgeList>
                            )}
                            {/* </Stack> */}
                          </TableCell>
                          ) : salesOrder ? (
                            renderSalesOrderListIdCell(row)
                          ) : (
                            renderSalesOrderListIdCell(row)
                          )}
                          {!noImage && !installsJobs &&<TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                            <img
                              src={Newimage || 'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'}
                              style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '5px',
                                margin: '0 auto',
                                display: 'block',
                                objectFit: 'fill',
                              }}
                              alt={Newname}
                            />
                          </TableCell>}
                          {/* <TableCell align="center">{row?.request_id}</TableCell> */}
                          {estimate ?
                            <>
                              {!salesOrder ? <TableCell align="left" sx={{
                                fontSize: '0.75rem',
                                '&:hover': {
                                  cursor: 'pointer',
                                  textDecoration: 'underline',
                                },
                              }}
                                onClick={() => {
                                  handleQuotationNameClick(row)
                                }}
                              >
                                <Stack direction="row" alignItems="center" spacing={1} sx={{ maxWidth: 280 }}>
                                  <Typography
                                    component="span"
                                    noWrap
                                    sx={{ fontSize: '0.75rem', maxWidth: row.rush ? 200 : 280 }}
                                  >
                                    {Newname}
                                  </Typography>
                                  {row.rush ? (
                                    <Chip label="Rush" size="small" sx={{ backgroundColor: 'red', color: 'white', fontWeight: 500, flexShrink: 0 }} />
                                  ) : null}
                                </Stack>
                              </TableCell>
                                :
                                <TableCell align="left" sx={{ fontSize: '0.75rem' }}

                                  onClick={
                                    CommunityProjects
                                      ? explodedPermissions?.some((permission) =>
                                        ['Add Jobs', 'Edit Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost'].includes(permission)
                                      ) || userType == 3
                                        ? () => navigate(PATH_DASHBOARD.project.viewproject + row?.id)
                                        : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                      : quotationView
                                        // ? row?.quotation_status != 6
                                          ? ((row?.quotation_status === 4 && row?.quotation === 0) || userType === 3)
                                            ? explodedPermissions?.some((permission) =>
                                              ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                                            ) || (userType === 3 && row?.status !== 6)
                                              ? () => handleOpenDetails(row?.id, row?.name)
                                              : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                            : explodedPermissions?.some((permission) =>
                                              ['Edit Estimate'].includes(permission)
                                            ) || (userType === 3 && status !== 6)
                                              ? () => handleOpenViewEstimate(row?.id, row?.name)
                                              : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                          // : () => enqueueSnackbar('Access Denied: Rejected Quotation', { variant: 'error' })
                                        : proposalView
                                          ? row?.proposal_count === 0
                                            ? () => handleOpenViewPurchaseOrder(row?.id, row?.name)
                                            : () => enqueueSnackbar('Access Denied: Proposals Submitted', { variant: 'error' })
                                          : designOrder
                                            ? explodedPermissions?.some((permission) =>
                                              ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                                              // ) || (userType === 3 && status !== 6)
                                            ) || (userType === 3)
                                            // ? () => navigate(`/dashboard/design-order/view/${row?.id}`)  
                                            ? () => handleOpenDetailsDesignOrder(row?.id, row?.name)
                                              : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                            : explodedPermissions?.some((permission) =>
                                              ['Create Request', 'Edit Request', 'Delete request', 'Add vendor to request', 'Add client to request'].includes(permission)
                                            ) || (userType === 3 && row?.status !== 6)
                                              ? userType !== 3
                                              // ? empty(row?.installationStatus)
                                              //     ? () => CommunityJob ? navigate(`/dashboard/official-request/view/${row?.id}`, { state: { fromProjects: true } }) : communityDesignOrder ? navigate(`/dashboard/design-order/view/${row?.id}`) : handleOpenViewSalesOrder(row?.id, row?.name)    
                                              ? empty(row?.installationStatus)
                                                  ? () => CommunityJob ? navigate(`/dashboard/official-request/view/${row?.id}`, { state: communityJobNavigateState }) : communityDesignOrder ? handleOpenDetailsDesignOrder(row?.id, row?.name) : handleOpenViewSalesOrder(row?.id, row?.name)
                                                  : () => enqueueSnackbar('Access Denied: Moved to installation Phase', { variant: 'error' })
                                                : quotationView
                                                  ? explodedPermissions?.some((permission) =>
                                                    ['View Estimate', 'Create Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                                                  )
                                                    ? () => handleOpenDetails(row?.id, row?.name)
                                                    : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                                  : designOrder
                                                    ? explodedPermissions?.some((permission) =>
                                                      ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                                                    )
                                                    // ? () => navigate(`/dashboard/design-order/view/${row?.id}`)  
                                                    ? () => handleOpenDetailsDesignOrder(row?.id, row?.name)
                                                      : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                                    : proposalView
                                                      ? row?.statusRfp === null || row?.statusRfp === 1
                                                        ? () => handleOpenViewPurchaseOrder(row?.id, row?.name)
                                                        : () => enqueueSnackbar('Access Denied: Proposal submission closed', { variant: 'error' })
                                                        // : () => CommunityJob ? navigate(`/dashboard/official-request/view/${row?.id}`, { state: { fromProjects: true } }) : communityDesignOrder ? navigate(`/dashboard/design-order/view/${row?.id}`) : handleOpenDetailsSalesOrder(row?.id, row?.name)
                                                        : () => CommunityJob ? navigate(`/dashboard/official-request/view/${row?.id}`, { state: communityJobNavigateState }) : communityDesignOrder ? handleOpenDetailsDesignOrder(row?.id, row?.name) : handleOpenDetailsSalesOrder(row?.id, row?.name)
                                              : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                  }
                                >
                                  <Typography
                                    variant="subtitle1"
                                    sx={{
                                    fontSize: '0.75rem',
                                    // mt: 2,
                                    // ml: 2,
                                    // maxWidth: userType != 3 && !CommunityProjects ? 150 : '70%',
                                    cursor: 'pointer',
                                    // display: 'inline-block',
                                    // overflow: 'hidden',
                                    // textOverflow: 'ellipsis',
                                    // whiteSpace: 'nowrap',
                                    // color: theme.palette.primary.main,
                                    '&:hover': {
                                      cursor: CommunityProjects
                                        ? explodedPermissions?.some((permission) =>
                                          ['Add Jobs', 'Edit Jobs', 'Activate/Deactivate Jobs', 'Delete Jobs', 'Manage Job Cost'].includes(permission)
                                        ) || (userType === 3 && row?.status !== 6)
                                          ? 'pointer'
                                          : 'default'
                                        : quotationView
                                          ? explodedPermissions?.some((permission) =>
                                            ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                                          ) || (userType === 3 && row?.status !== 6)
                                            ? 'pointer'
                                            : 'default'
                                          : designOrder
                                            ? explodedPermissions?.some((permission) =>
                                              ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                                            ) || (userType === 3 && row?.status !== 6)
                                              ? 'pointer'
                                              : 'default'
                                            : explodedPermissions?.some((permission) =>
                                              ['Create Request', 'Edit Request', 'Delete request', 'Add vendor to request', 'Add client to request'].includes(permission)
                                            ) || (userType === 3 && row?.status !== 6)
                                              ? 'pointer'
                                              : 'default',
                                    },
                                  }}
                                >

                                  {Newname}
                                  </Typography>
                                </TableCell>}
                            </>
                            :
                            <TableCell align="left" sx={{
                              fontSize: '0.75rem',
                              '&:hover': {
                                cursor: 'pointer',
                                textDecoration: 'underline',
                              },
                            }}
                              onClick={
                                (explodedPermissions?.some((permission) =>
                                  ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                                ) ||
                                  (userType === 3 && status !== 6)) &&
                                  !(userType === 3 && accept_status === 2)
                                  // ? () => navigate(`/dashboard/design-order/view/${row?.id}`)
                                  ? () => handleOpenDetailsDesignOrder(row?.id, row?.name)
                                  : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                              }
                            >{Newname}
                            </TableCell>}

                          {noImage && !estimate && (
                              <TableCell>
                                {row.rush ? 
                                  <Chip
                                    label="Rush"
                                    size="small"
                                    sx={{
                                        backgroundColor: 'red',
                                        color: 'white',
                                        fontWeight: 500,
                                        }}
                                   />
                                 :""}
                               </TableCell>
                          )}

                          {/* <TableCell align="center">{row?.community_name}</TableCell>
                            <TableCell align="center">{row?.authorized_by}</TableCell>
                            <TableCell align="center">{row?.member_count}</TableCell> */}
                          {/* <TableCell align="center">{row?.city==='DefaultCity' ? '' : row?.city}</TableCell> */}

                          {estimate && proposalView  ?

                            <>
                              <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                                  <Label
                                    variant={
                                      theme.palette.mode === 'light' ? 'ghost' : 'filled'
                                    }
                                    color={'default'}
                                  >
                                    {/* <Tooltip title={row?.community_name}> */}
                                      <Typography
                                        variant="subtitle2"
                                        sx={{
                                          fontSize: '0.75rem',
                                          cursor: 'pointer',
                                          display: 'inline-block',
                                          maxWidth: 100, // Adjust as necessary
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        <span
                                          style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {installation_start_date && installation_end_date 
                                            ? `${moment.unix(installation_start_date).format('MM/DD/YYYY')} - ${moment.unix(installation_end_date).format('MM/DD/YYYY')}`
                                            : moment.unix(participation_ends).format('MM/DD/YYYY')
                                          }
                                        </span>
                                      </Typography>
                                    {/* </Tooltip> */}
                                  </Label>                               
                              </TableCell>                              
                            </>
                            : estimate ?
                            <>
                              <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                                {community_name ? (
                                  <Label
                                    variant={
                                      theme.palette.mode === 'light' ? 'ghost' : 'filled'
                                    }
                                    color={'warning'}
                                  >
                                    <Tooltip title={row?.community_name}>
                                      <Typography
                                        variant="subtitle2"
                                        sx={{
                                          fontSize: '0.75rem',
                                          cursor: 'pointer',
                                          display: 'inline-block',
                                          maxWidth: 80, // Adjust as necessary
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        <span
                                          style={{
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {community_name}
                                        </span>
                                      </Typography>
                                    </Tooltip>
                                  </Label>
                                ) : (
                                  <Label
                                    variant={
                                      theme.palette.mode === 'light' ? 'ghost' : 'filled'
                                    }
                                    color={'error'}
                                  >
                                    No project
                                  </Label>
                                )}
                              </TableCell>
                              {noImage && !installsJobs &&<TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                                <Label
                                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                  color="secondary"
                                >
                                  <Tooltip title={row?.customer_name?.trim() || 'N/A'}>
                                    <Typography
                                      variant="subtitle2"
                                      sx={{
                                        fontSize: '0.75rem',
                                        cursor: 'pointer',
                                        display: 'inline-block',
                                        maxWidth: 150, // Adjust as necessary
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      <span
                                        style={{
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        {row?.customer_name?.trim() || 'N/A'}
                                      </span>
                                    </Typography>
                                  </Tooltip>
                                </Label>
                              </TableCell>
                              }

                            </>:null
                          }
                          {estimate && proposalView ?
                          
                          <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                              <Label
                                variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                color={getStatusColorAndLabelForProposal(
                          userType != 3 ? (row.paymentMode ? 7 : row.awarded ? 2 : 1) : row.paymentMode ? 7 : row.statusRfp,
                        ).color} >
                                {getStatusColorAndLabelForProposal(
                              userType != 3 ? (row.paymentMode? 7:row.awarded ? 2 : 1) : row.paymentMode ? 7 : row.statusRfp,
                            ).label}
                              </Label>
                            </TableCell>
                          
                          :estimate ?
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                              <Label
                                variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                color={salesOrder ?
                                  salesOrderStatusMeta.color : getStatusColorAndLabelQuickbid(
                                    row?.quotation_status,
                                    row?.quotation,
                                    row?.estimate_job_status,
                                    hold,
                                    row?.manager_approval_required,
                                    row?.send_client_app_req,
                                    row?.send_to_client,
                                    row?.send_for_manager_approval,
                                    row?.is_request_estimate,
                                  ).color} >
                                {salesOrder ?
                                  salesOrderStatusMeta.label : getStatusColorAndLabelQuickbid(
                                    row?.quotation_status,
                                    row?.quotation,
                                    row?.estimate_job_status,
                                    hold,
                                    row?.manager_approval_required,
                                    row?.send_client_app_req,
                                    row?.send_to_client,
                                    row?.send_for_manager_approval,
                                    row?.is_request_estimate,
                                  ).label}
                              </Label>
                            </TableCell>
                            :
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                              <Label
                                variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                color={getStatusColorAndLabelDesignOrder(status, hold, row?.design_order_job_status, row?.send_client_app_req, row?.attachment_count, attachment, row?.is_in_queue).color} >
                                {getStatusColorAndLabelDesignOrder(status, hold, row?.design_order_job_status, row?.send_client_app_req, row?.attachment_count, attachment, row?.is_in_queue).label}
                              </Label>
                            </TableCell>
                          }
                          {estimate && salesOrder && proposalView && isAdminUser (userType) && (
                            <TableCell
                              align="left"
                              sx={{ fontSize: '0.75rem', verticalAlign: 'middle' }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
                                {Number(row?.proposal_count || 0) > 0 && !row?.awarded && !row?.paymentMode && (row?.statusRfp == null || Number(row?.statusRfp) === 1) && (
                                  <Box onMouseDown={(event) => event.stopPropagation()}>
                                    <AnimatedButton
                                      size="small"
                                      title="Award"
                                      startIcon={<EmojiEvents sx={{ width: 14, height: 14 }} />}
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        if (awardActionLoadingId === (row?.proposal_id || row?.id)) return;
                                        onProposalAwardAction?.(row, 'award');
                                      }}
                                    />
                                  </Box>
                                )}
                                {Number(row?.proposal_count || 0) > 0 && row?.awarded && !row?.paymentMode && (row?.statusRfp == null || Number(row?.statusRfp) === 2) && (
                                  <Box onMouseDown={(event) => event.stopPropagation()}>
                                    <AnimatedButton
                                      size="small"
                                      title="Mark As Paid"
                                      startIcon={<Payment sx={{ width: 14, height: 14 }} />}
                                      onClick={(event) => {
                                        event.stopPropagation();
                                        if (awardActionLoadingId === (row?.proposal_id || row?.id)) return;
                                        onProposalAwardAction?.(row, 'payment');
                                      }}
                                    />
                                  </Box>
                                )}
                              </Stack>
                            </TableCell>
                          )}
                          {estimate ?
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                              <>
                                {salesOrder ?
                                  <>
                                    {((userType != 3 && !CommunityProjects) || proposalView) && (
                                      <Button
                                        onClick={
                                          CommunityProjects
                                            ? explodedPermissions?.some((permission) =>
                                              [
                                                'Add Jobs',
                                                'Edit Jobs',
                                                'Activate/Deactivate Jobs',
                                                'Delete Jobs',
                                                'Manage Job Cost',
                                              ].includes(permission),
                                            ) || userType == 3
                                              ? () => navigate(PATH_DASHBOARD.project.viewproject + id)
                                              : () =>
                                                enqueueSnackbar(
                                                  'Access Denied: You do not have sufficient permissions',
                                                  { variant: 'error' },
                                                )
                                            : quotationView
                                              ? (explodedPermissions?.some((permission) =>
                                                ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                                              ) ||
                                                (userType === 3 && status !== 6)) &&
                                                !(userType === 3 && accept_status === 2)
                                                ? () => handleOpenDetails(id, name)
                                                : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                              // ? () => handleOpenDetails(id, name)
                                              // ? () => navigate(`/dashboard/quick-bid/view/${id}`)
                                              : designOrder
                                                  ? (explodedPermissions?.some((permission) =>
                                                    ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                                                  ) ||
                                                  (userType === 3 && status !== 6)) &&
                                                  !(userType === 3 && accept_status === 2)
                                                  // ? () => navigate(`/dashboard/design-order/view/${id}`)
                                                  ? () => handleOpenDetailsDesignOrder(id, name)
                                                  : () => enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                                                : (explodedPermissions?.some((permission) =>
                                                  [
                                                    'Edit Request',
                                                    'View request',
                                                    'Delete request',
                                                    'Add vendor to request',
                                                    'Add client to request',
                                                  ].includes(permission),
                                                ) ||
                                                  (userType === 3 && status !== 6)) &&
                                                  !(userType === 3 && accept_status === 2)
                                                  ? proposalView
                                                    ? () => handleOpenDetailsPurchaseOrder(id, name, false)
                                                    : // navigate(`/dashboard/rfp/view/${id}`)
                                                    () =>
                                                      CommunityJob ?
                                                        navigate(`/dashboard/official-request/view/${id}`, { state: communityJobNavigateState }) :
                                                        // communityDesignOrder ? navigate(`/dashboard/design-order/view/${id}`) :
                                                        communityDesignOrder ? handleOpenDetailsDesignOrder(id, name) :
                                                          handleOpenDetailsSalesOrder(id, name)
                                                  : () =>
                                                    enqueueSnackbar(
                                                      'Access Denied: You do not have sufficient permissions',
                                                      { variant: 'error' },
                                                    )
                                        }
                                        variant="subtitle1"
                                        sx={{
                                          mt: 3,
                                          mr: 2,
                                          color: theme.palette.primary.main,

                                          '&:hover': {
                                            cursor: CommunityProjects
                                              ? explodedPermissions?.some((permission) =>
                                                [
                                                  'Add Jobs',
                                                  'Edit Jobs',
                                                  'Activate/Deactivate Jobs',
                                                  'Delete Jobs',
                                                  'Manage Job Cost',
                                                ].includes(permission),
                                              )
                                                ? 'pointer'
                                                : 'default'
                                              : quotationView
                                                ? (explodedPermissions?.some((permission) =>
                                                  ['View Estimate', 'Edit Estimate', 'Delete Estimate'].includes(permission)
                                                ) ||
                                                  (userType === 3 && status !== 6)) &&
                                                  !(userType === 3 && accept_status === 2)
                                                  ? 'pointer'
                                                  : 'default'
                                                : designOrder
                                                  ? (explodedPermissions?.some((permission) =>
                                                    ['View Design Order', 'Edit Design Order', 'Delete Design Order'].includes(permission)
                                                  ) ||
                                                    (userType === 3 && status !== 6)) &&
                                                    !(userType === 3 && accept_status === 2)
                                                    ? 'pointer'
                                                    : 'default'
                                                  :
                                                  (explodedPermissions?.some((permission) =>
                                                    [
                                                      'Edit Request',
                                                      'View request',
                                                      'Delete request',
                                                      'Add vendor to request',
                                                      'Add client to request',
                                                    ].includes(permission),
                                                  ) ||
                                                    (userType === 3 && status !== 6)) &&
                                                    !(userType === 3 && accept_status === 2)
                                                    ? 'pointer'
                                                    : 'default',
                                          },
                                        }}
                                      >
                                        Details
                                      </Button>
                                    )}
                                  </>
                                  :
                                  <Button onClick={() => {
                                    salesOrder ? handleQuotationEditClick(row) : handleQuotationNameClick(row)
                                  }}>
                                    Details
                                  </Button>

                                }
                              </>
                            </TableCell>
                            :
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>

                              {(userType != 3 && currentTab != "APPROVED" && designOrder) && (status === 1 || status === 6) &&
                                <UserMoreMenu
                                  hold={hold}
                                  {...(currentTab != "APPROVED" && (status === 1 || status === 6) ? {
                                    onHold: () => {
                                      if (explodedPermissions?.some(permission => ['Hold Design Order Jobs'].includes(permission))) {
                                        setOpenHoldPopup(true);
                                      } else {
                                        enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                                      }
                                    }
                                  } : {})}

                                />
                              }
                              <Dialog
                                open={openHoldPopup}
                                onClose={() => {
                                  setOpenHoldPopup(false);
                                  setHoldReason('');
                                }}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                                BackdropProps={{ invisible: true }}
                              >
                                <DialogTitle id="alert-dialog-title">
                                  {hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
                                </DialogTitle>
                                <DialogContent>
                                  <DialogContentText id="alert-dialog-description">
                                    {
                                      designOrder ? (
                                        hold === 1
                                          ? 'You want to move this Design Order from Hold.'
                                          : 'You want to move this Design Order to Hold.'
                                      ) : (
                                        hold === 1
                                          ? 'You want to move this Sales Order from Hold.'
                                          : 'You want to move this Sales Order to Hold.'
                                      )
                                    }
                                    {/* {hold === 1
                                                            ? 'You want to move this Design Order from Hold.'
                                                            : 'You want to move this Design Order to Hold.'} */}
                                  </DialogContentText>
                                  {(hold === 0) ? (
                                    <TextField
                                      sx={{ width: 400 }}
                                      label="Reason"
                                      type="text"
                                      multiline
                                      minRows={3}
                                      maxRows={7}
                                      value={holdReason}
                                      onChange={(e) => {
                                        setHoldReason(e.target.value);
                                        if (holdReasonError) setHoldReasonError('');
                                      }}
                                      error={Boolean(holdReasonError)}
                                      helperText={holdReasonError}
                                    />
                                  ) : ''}
                                </DialogContent>
                                <DialogActions>
                                  <Button
                                    size="small"
                                    variant="contained"
                                    onClick={async () => {
                                      if ((hold === 0) && !holdReason.trim()) {
                                        setHoldReasonError(`Reason is required to put this ${designOrder ? 'Design Order on Hold' : 'Sales Order on Hold'}.`);
                                        return;
                                      }

                                      setIsSubmittingHold(true);
                                      if (designOrder) {
                                        await handleUpdateHoldStatus(holdReason, row?.id);
                                      } else {
                                        await handleUpdateSalesOrderHoldStatus(holdReason, row?.id)
                                      }
                                      setIsSubmittingHold(false);
                                      setOpenHoldPopup(false);
                                      setHoldReason('');
                                      setHoldReasonError('');
                                    }}
                                    disabled={isSubmittingHold}
                                  >
                                    {isSubmittingHold ? (
                                      <CircularProgress size={20} color="inherit" />
                                    ) : (
                                      'OK'
                                    )}
                                  </Button>
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    onClick={() => {
                                      setOpenHoldPopup(false);
                                      setHoldReason('');
                                    }}
                                    sx={{ color: theme.palette.error.main }}
                                  >
                                    Cancel
                                  </Button>
                                </DialogActions>
                              </Dialog>
                            </TableCell>
                          }
                        </TableRow>
                      ];

                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={tableColumnCount} />
                      </TableRow>
                    )}
                  </TableBody>
                    {isUserNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <SearchNotFound searchQuery={filterName} />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>
  
              {/* <TablePagination
                rowsPerPageOptions={[6, 12, 27, 39]}
                component="div"
                 count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
              /> */}
            </Card>
           
          </Grid>
        
        
      </Grid>
    
             <Modal
                    open={deleteTeam}
                    handleClose={() => {
                      setDeleteTeam(false);
                    }}
                  // modalTitle={'Remove Team Member'}
                  >
                    <FormikProvider value={Formik}>
                      <Form noValidate autoComplete="off">
                        <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                          <Avatar
                            alt={setectedRow?.name}
                            src={setectedRow?.profile_pic ? setectedRow?.profile_pic : setectedRow?.name }
                            sx={{ width: 150, height: 150, margin: "auto", }}
                          />
                          <Typography variant="h5" sx={{ color: 'primary.secondary', alignSelf: 'center' }}>
                            Are you sure you want to delete {setectedRow?.name} ?</Typography>
                        </Stack>
                        <Grid container justifyContent="center" alignItems="center">
                          <Grid item xs={12} md={6}>
                            <Box sx={{ my: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                              <Button variant="contained"
                                onClick={() => {
                                  if(fromClient !== true){
                                    setDeleteTeam(false);
                                    changeStatus(deleteId, 2);
                                  // navigate(PATH_DASHBOARD.callCenter.teams, { state: { data: deleteId } });
                                  }else{
                                    handleDeleteClient(deleteId,2)
                                    
                                  }
                                }}>
                                Yes, Delete it!
                              </Button>
                              <Button variant="outlined" onClick={() => {
                                setDeleteTeam(false);
                              }}>
                                No, Cancel pls!
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                      </Form>
                    </FormikProvider>
                  </Modal>
</>
  );
}
